<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="columns columns--full is-vcentered onboarding-create-site__step9">
    <div
      class="column has-text-centered onboarding-create-site__description--step9"
    >
      <div class="onboarding-create-site__description--width-80">
        <h1 class="onboarding-create-site__title has-text-weight-bold">
          Por fim, escolha um tema para seu site
        </h1>
        <p class="onboarding-create-site__paragraph">
          Separamos alguns dos melhores temas para vocês, mas vocês podem
          personalizar e ver mais<br />opções sempre que quiserem.
        </p>
        <themes :stepNumber="stepNumber" :content="optionsSiteModel" />
        <p @click="clearStepLocalstorage()">
          <router-link
            class="onboarding-create-site__jump-all-steps--link"
            :to="{ path: `/onboarding/passo-${this.stepNumber}` }"
            replace
            >Escolher depois</router-link
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import verifyOnboardingCompleteMixin from '@/mixins/verifyOnboardingCompleteMixin'

import themes from '@/components/OnboardingCreationSite/ModelSite.vue'

import cartasDeAmor from '@/assets/img/onboarding-create-site/modelo-cartas-de-amor.png'
import siteCeuDePetalas from '@/assets/img/onboarding-create-site/modelo-site-ceu-de-petalas.png'
import floresta from '@/assets/img/onboarding-create-site/modelo-site-floresta.png'
import garden from '@/assets/img/onboarding-create-site/modelo-site-garden.png'
import linhasDoAmor from '@/assets/img/onboarding-create-site/modelo-site-linhas-do-amor.png'
import siteNaBeiraDoMar from '@/assets/img/onboarding-create-site/modelo-site-na-beira-do-mar.png'
import nosBlack from '@/assets/img/onboarding-create-site/modelo-site-nos.png'
import siteSerenataDeAmor from '@/assets/img/onboarding-create-site/modelo-site-serenata-de-amor.png'
import siteSerenity from '@/assets/img/onboarding-create-site/modelo-site-serenity.png'

export default {
  mixins: [verifyOnboardingCompleteMixin],

  components: {
    themes,
  },

  props: {
    stepNumber: Number,
  },

  data() {
    return {
      optionsSiteModel: [
        {
          theme_id: 60,
          name: 'Linhas do Amor',
          img: linhasDoAmor,
          withColorsVariation: true,
        },
        {
          theme_id: 59,
          name: 'Cartas de Amor',
          img: cartasDeAmor,
          withColorsVariation: true,
        },
        {
          theme_id: 58,
          name: 'Floresta',
          img: floresta,
          withColorsVariation: true,
        },
        {
          theme_id: 57,
          name: 'Garden',
          img: garden,
          withColorsVariation: true,
        },
        {
          theme_id: 56,
          name: 'Nós',
          img: nosBlack,
          withColorsVariation: true,
        },
        {
          theme_id: 55,
          name: 'Céu de Pétalas',
          img: siteCeuDePetalas,
          withColorsVariation: true,
        },
        {
          theme_id: 54,
          name: 'Na Beira do Mar',
          img: siteNaBeiraDoMar,
          withColorsVariation: false,
        },
        {
          theme_id: 53,
          name: 'Serenata de Amor',
          img: siteSerenataDeAmor,
          withColorsVariation: true,
        },
        {
          theme_id: 52,
          name: 'Serenity',
          img: siteSerenity,
          withColorsVariation: true,
        },
      ],
    }
  },

  computed: {
    answerUser() {
      return this.$store.state.onboardingCreateSite.answersOfStep
    },
  },

  methods: {
    clearStepLocalstorage() {
      const dataLocalstorage = JSON.parse(
        localStorage.getItem(`onboarding_wed${this.answerUser.wed_id}`)
      )

      dataLocalstorage.website_theme = null

      localStorage.setItem(
        `onboarding_wed${this.answerUser.wed_id}`,
        JSON.stringify(dataLocalstorage)
      )
    },
  },
}
</script>

<style lang="scss">
.onboarding-create-site {
  &__description {
    &--step9 {
      padding: 30px 20px 20px;
      max-width: 1300px;
      margin: 0 auto;

      @media (min-width: $tablet) {
        padding: 30px 50px;
      }
    }
  }
}
</style>
